








import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import VueSlider from 'vue-slider-component';
import {
  Direction,
  TooltipProp,
  Position,
  TooltipFormatter,
  Marks,
  MarksFunction,
  Value,
} from 'vue-slider-component/typings/typings';

@Component({
  name: 'BaseSlider',
  components: {
    VueSlider,
  },
})
export default class BaseSlider extends Vue {
  @Model('change') value: Value | Array<Value>;
  @Prop() direction: Direction;
  @Prop() data: Array<number> | Array<string> | Array<object> | object;
  @Prop() dataValue: string;
  @Prop() dataLabel: string;
  @Prop() min: number;
  @Prop() max: number;
  @Prop() interval: number;
  @Prop() disabled: boolean;
  @Prop() tooltip: TooltipProp;
  @Prop() tooltipPlacement: Position;
  @Prop() tooltipFormatter: TooltipFormatter | Array<TooltipFormatter>;
  @Prop() minRange: number;
  @Prop() maxRange: number;
  @Prop() marks: boolean | Marks | Array<number | string> | MarksFunction;
  @Prop() lazy: boolean;
  @Prop() adsorb: boolean;
  @Prop({ default: 2 }) height: number;
}
